import React from 'react'
import classNames from 'classnames'
import { LoadingLine } from 'components/Layout/LoadingLine'
import SearchRow from './SearchRow'
import { TOP_BAR_HEIGHT } from './TopBarRight'

export type TopBarLeftProps = {
  className?: string
  width?: number
  showLoadingPlaceHolder?: boolean
}

export const TopBarLeft = ({
  width,
  showLoadingPlaceHolder,
  className,
}: TopBarLeftProps) => (
  <div
    className={classNames(
      'flexbox flexbox-align-center zindex-large background-shade-100 border-bottom-medium border-shade-50',
      className
    )}
    style={{ height: TOP_BAR_HEIGHT, width }}
  >
    {showLoadingPlaceHolder ? (
      <LoadingLine lineWidth="50%" marginBottom={0} />
    ) : (
      <SearchRow />
    )}
  </div>
)
